import { App } from '../../App.js'
import CONST_SOCKET from '../../const/socket'
import { addNewPostbackNodeToEditor } from '../../utils/functions'

// eslint-disable-next-line
export default async (component, event, ui) => {
  App.editor.view.area.pointermove(event)
  const { x, y } = App.editor.view.area.mouse
  const newSequenceSingleNode = await component.createNode()
  newSequenceSingleNode.position = [x, y]

  App.editor.addNode(newSequenceSingleNode)

  const childNewPostbackNodePosition = [x + 250, y]
  const childNewPostbackNode = await addNewPostbackNodeToEditor(childNewPostbackNodePosition)

  App.editor.connect(
    newSequenceSingleNode.outputs.get(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT),
    childNewPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
  )
}